import NoResultIcon from '@/common/assets/icons/NoResultIcon.svg?react';
import BaseCheckbox from '@/common/components/BaseCheckbox/BaseCheckBox';
import CircularLoading from '@/common/components/base/Loading/CircularLoading.tsx';
import Button from '@/common/components/base/button/Button';
import Input from '@/common/components/base/input/base/Input.tsx';
import createAttachment from '@/common/components/base/input/base/helpers/createAttachment';
import ArrowDownAttachment from '@/common/components/base/input/modalInput/attachments/ArrowDownAttachment';
import LoadingAttachment from '@/common/components/base/input/modalInput/attachments/LoadingAttachment';
import { MultipleCheckboxesModalInputType } from '@/common/components/base/input/multipleCheckboxesModalInput/MultipleCheckboxesModalInput.type';
import TextInput from '@/common/components/base/input/textInput/TextInput.tsx';
import MainModal from '@/common/components/base/modal/Modal.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import useModal from '@/common/hooks/useModal.ts';
import { SelectionOptionsType } from '@/common/types/SelectionOptions.type.ts';
import { requiredText } from '@/common/utils/rules/publicRules';
import { useEffect, useState } from 'react';
import {
  FormProvider,
  useController,
  useForm,
  useFormContext,
} from 'react-hook-form';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const MultipleCheckboxesModalInput = ({
  name,
  disabled,
  defaultValue = [],
  label,
  rules,
  placeholder,
  onChange,
  loading,
  searchOptions,
  endIcon,
  endAttachments,
  children,
  inputProps,
  optionalLabel,
  hasLabel,
  hasErrorMassage,
  data,
  hasInput = 'exist',
  outerOpen = false,
  disabledCheckBoxes,
  CheckedTheDisabledCheckBoxes = false,
}: MultipleCheckboxesModalInputType) => {
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    rules,
    control,
    name,
    defaultValue,
  });

  const { openModal, open, closeModal } = useModal();

  const [selectedValues, setSelectedValues] = useState<SelectionOptionsType[]>(
    field.value || [],
  );

  const [searchableInsurances, setSearchableInsurances] = useState<
    SelectionOptionsType<string | number>[]
  >(data ?? []);

  const toggleSelection = (singleOption: SelectionOptionsType) => {
    setSelectedValues((prev) =>
      selectedValues.some((item) => item.value === singleOption.value)
        ? prev.filter((item) => item.value !== singleOption.value)
        : [...prev, singleOption],
    );
  };
  const searchHandler = (value: string) => {
    const filteredInsurances = data?.filter((item) => {
      return item.label.toLowerCase().includes(value.toLowerCase());
    });
    setSearchableInsurances(filteredInsurances! ?? []);
  };

  const confirmSelection = () => {
    field.onChange(selectedValues);
    onChange?.(selectedValues);
    closeModal();
  };
  const endAttachment =
    endAttachments ??
    (endIcon
      ? [
          createAttachment({
            element: endIcon,
            shouldRender: true,
            size: 'medium',
          }),
        ]
      : loading
        ? [LoadingAttachment]
        : [ArrowDownAttachment]);

  const checkDisablity = () => {
    if (selectedValues.length >= field.value?.length) {
      return selectedValues.every((item) =>
        field.value?.some(
          (single: SelectionOptionsType) => single.value === item.value,
        ),
      );
    } else {
      return field.value?.every((item: SelectionOptionsType) =>
        selectedValues?.find((item2) => item2.value === item.value),
      );
    }
  };
  useEffect(() => {
    const SelectedValues = data?.filter((item) =>
      field?.value?.some(
        (singleOption: SelectionOptionsType) =>
          item.value === singleOption.value,
      ),
    );
    setSelectedValues(SelectedValues || []);
    setSearchableInsurances(data || []);
  }, [open, data, outerOpen]);
  return hasInput === 'exist' ? (
    <>
      <Input
        inputProps={{
          value: selectedValues.length
            ? selectedValues.length === 1
              ? selectedValues[0].label
              : `${selectedValues.length}`
            : '',
          placeholder,
          disabled,
          readOnly: true,
          onFocus: openModal,
          ...inputProps,
        }}
        hasLabel={hasLabel}
        hasErrorMassage={hasErrorMassage}
        optionalLabel={optionalLabel}
        inputRef={field.ref}
        errorMessage={fieldState?.error?.message}
        label={label}
        endAttachments={endAttachment}
      />

      <MainModal open={open} closeModal={closeModal}>
        {searchOptions ? (
          <MultipleCheckboxesModalInputSearch searchHandler={searchHandler} />
        ) : null}
        {loading ? (
          <Box display="flex" justifyContent="center" mt="50px">
            <CircularLoading color="colors.purple-primary" />
          </Box>
        ) : (
          (children?.(closeModal) ?? (
            <Box className={css({ maxHeight: '50vh', overflowY: 'auto' })}>
              <OptionModal
                selectedValues={selectedValues}
                toggleSelection={toggleSelection}
                options={searchableInsurances}
                disabledCheckBoxes={disabledCheckBoxes}
                CheckedTheDisabledCheckBoxes={CheckedTheDisabledCheckBoxes}
              />
              <Box
                backgroundColor="gray-4"
                position="sticky"
                bottom="0"
                right="0"
                left="0"
                zIndex="layout"
              >
                <Button
                  disabled={checkDisablity()}
                  mt="20px"
                  width="100%"
                  onClick={confirmSelection}
                >
                  تائید
                </Button>
              </Box>
            </Box>
          ))
        )}
      </MainModal>
    </>
  ) : outerOpen ? (
    <>
      {searchOptions ? (
        <MultipleCheckboxesModalInputSearch searchHandler={searchHandler} />
      ) : null}
      {loading ? (
        <Box display="flex" justifyContent="center" mt="50px">
          <CircularLoading color="colors.purple-primary" />
        </Box>
      ) : (
        (children?.(closeModal) ?? (
          <Box className={css({ maxHeight: '50vh', overflowY: 'auto' })}>
            <OptionModal
              selectedValues={selectedValues}
              toggleSelection={toggleSelection}
              options={searchableInsurances}
              disabledCheckBoxes={disabledCheckBoxes}
              CheckedTheDisabledCheckBoxes={CheckedTheDisabledCheckBoxes}
            />
            <Box
              backgroundColor="gray-4"
              position="sticky"
              bottom="0"
              right="0"
              left="0"
              zIndex="layout"
            >
              <Button
                disabled={checkDisablity()}
                mt="20px"
                width="100%"
                onClick={confirmSelection}
              >
                تائید
              </Button>
            </Box>
          </Box>
        ))
      )}
    </>
  ) : null;
};
export default MultipleCheckboxesModalInput;

const OptionModal = ({
  options,
  toggleSelection,
  selectedValues,
  disabledCheckBoxes,
  CheckedTheDisabledCheckBoxes = false,
}: {
  options?: SelectionOptionsType[];
  toggleSelection: (option: SelectionOptionsType) => void;
  selectedValues: SelectionOptionsType[];
  disabledCheckBoxes?: SelectionOptionsType[];
  CheckedTheDisabledCheckBoxes: boolean;
}) => {
  return (
    <Box>
      {options?.length === 0 ? (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          mt="50px"
          maxHeight="50vh"
          overflowY="auto"
        >
          <NoResultIcon />
          <Typography
            textStyle="b2"
            textAlign="center"
            py="13px"
            color="{colors.black-3}"
          >
            نتیجه‌ای یافت نشد !
          </Typography>
        </Box>
      ) : (
        <Box>
          {options?.map((option) => (
            <Box
              key={option.value}
              display="flex"
              alignItems="center"
              py="10px"
              onClick={(event) => {
                if (
                  !disabledCheckBoxes?.some(
                    (item) => item.value === option.value,
                  )
                ) {
                  toggleSelection(option);
                  event.stopPropagation();
                } else {
                  undefined;
                }
              }}
            >
              <BaseCheckbox
                checked={
                  CheckedTheDisabledCheckBoxes
                    ? [...selectedValues, ...(disabledCheckBoxes ?? [])].some(
                        (item) => item.value === option.value,
                      )
                    : selectedValues.some((item) => item.value === option.value)
                }
                disabled={disabledCheckBoxes?.some(
                  (item) => item.value === option.value,
                )}
              />
              <Typography mr="8px">{option.label}</Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

const MultipleCheckboxesModalInputSearch = ({
  searchHandler,
}: {
  searchHandler: (search: string) => void;
}) => {
  const formController = useForm();
  return (
    <Box>
      <FormProvider {...formController}>
        <TextInput
          rules={{ required: requiredText }}
          name="search"
          placeholder="جستجو"
          onChange={searchHandler}
        />
      </FormProvider>
    </Box>
  );
};
